import * as React from "react";
const SvgC = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("title", null, "file_type_c2"), /* @__PURE__ */ React.createElement("path", { d: "M23,19.418A6.971,6.971,0,1,1,22.95,12.5l6.093-3.509a14,14,0,1,0,.036,13.95Z", style: {
  fill: "#005f91"
} }));
export default SvgC;
